import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Купить SKODA – модельный ряд новых автомобилей Шкода на официальном сайте в России",
  "description": "Сайт компании ŠKODA AUTO Россия. Новые автомобили европейского производства марки ŠKODA по официальным ценам. Каталог автомобилей Шкода на сайте. Телефон горячей линии: 8 800 555-01-01.",
  "keywords": "автомобили Шкода,автомобили,SKODA,новая Шкода,купить в москве,официальный сайт"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MainCarouselQueried = makeShortcode("MainCarouselQueried");
const SaleEvent = makeShortcode("SaleEvent");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const ModelTilesQueried = makeShortcode("ModelTilesQueried");
const QueriedSpecialsList = makeShortcode("QueriedSpecialsList");
const QueriedGallery = makeShortcode("QueriedGallery");
const AvnWidgetContainer = makeShortcode("AvnWidgetContainer");
const AvnWidgetTile = makeShortcode("AvnWidgetTile");
const ProperLink = makeShortcode("ProperLink");
const PaddedTilesContainer = makeShortcode("PaddedTilesContainer");
const PaddedTilesTile = makeShortcode("PaddedTilesTile");
const SocialBlockHOC = makeShortcode("SocialBlockHOC");
const SocialSliderQueried = makeShortcode("SocialSliderQueried");
const QueriedDlNew = makeShortcode("QueriedDlNew");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <MainCarouselQueried tags="mainpage" mdxType="MainCarouselQueried" />
    <SaleEvent tags="saleevent-index-1" mdxType="SaleEvent" />
    <SaleEvent tags="saleevent-index-2" mdxType="SaleEvent" />
    <SaleEvent tags="saleevent-index-3" mdxType="SaleEvent" />
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Модели ŠKODA</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Что Вам больше по душе — динамичная поездка по городским трассам или
    покорение неизведанных горизонтов? Изысканная неспешная элегантность или
    возможность успеть везде и всюду? Какой бы стиль жизни Вы ни предпочитали,
    модельный ряд ŠKODA наверняка подарит Вам немало замечательных открытий
  </DefaultSectionText>
  <ModelTilesQueried mdxType="ModelTilesQueried" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Акции ŠKODA</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Знаете, что может быть лучше автомобиля ŠKODA? Автомобиль ŠKODA на
    специальных условиях. Набор преимуществ на покупку нового автомобиля,
    привлекательные ставки на кредитные программы, дополнительные выгоды от
    сдачи старого авто в trade-in — мы делаем всё, чтобы наши автомобили
    оставались доступными, а условия выбирали Вы.
  </DefaultSectionText>
  <QueriedSpecialsList slidesToShow={3} hideDate slider greedy tags="special service-offer" mdxType="QueriedSpecialsList" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Покупка</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    В автомобили ŠKODA можно влюбиться всего лишь увидев фотографии на нашем
    сайте. Но если Вам нужны дополнительные причины для покупки - мы подготовили
    ряд сервисов, которые помогут Вам узнать больше о моделях ŠKODA, попробовать
    любую из них на дороге, а также облегчить процесс выбора и покупки Вашей
    новой ŠKODA.
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="4" tags="main services" mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Автомобили в наличии </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Посмотрите какие автомобили ŠKODA есть в наличии у дилеров в Вашем городе
    прямо сейчас. Здесь вы найдете описание комплектаций и актуальные цены, а
    также сможете сравнить и забронировать понравившиеся автомобили одним
    кликом.
  </DefaultSectionText>
  <AvnWidgetContainer mdxType="AvnWidgetContainer">
    <AvnWidgetTile imgSrc="/m/avn-rapid-new-style-white.png" title="Rapid" price="1 602 000 ₽" href="https://cars.skoda-avto.ru/rapid" mdxType="AvnWidgetTile" />
    <AvnWidgetTile imgSrc="/m/avn-octavia-new.png" title="Octavia" price="2 613 000 ₽" href="https://cars.skoda-avto.ru/octavia" mdxType="AvnWidgetTile" />
    <AvnWidgetTile imgSrc="/m/avn-karoq-grey-index.png" title="Karoq" price="2 716 000 ₽" href="https://cars.skoda-avto.ru/karoq" mdxType="AvnWidgetTile" />
    <AvnWidgetTile imgSrc="/m/avn_kodiaq.png" title="Kodiaq" price="3 364 000 ₽" href="https://cars.skoda-avto.ru/kodiaq" mdxType="AvnWidgetTile" />
    <AvnWidgetTile imgSrc="/m/avn_superb.png" title="Superb" price="3 386 000 ₽" href="https://cars.skoda-avto.ru/superb" mdxType="AvnWidgetTile" />
  </AvnWidgetContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">ŠKODA СЕРВИС</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Чтобы автомобиль оставался надежным инструментом для решения Ваших задач
    рекомендуется регулярно проходить техническое обслуживание в одном из
    официальных дилерских центрах.
    <br />
    Подробные ответы на вопросы по регламентному техническому обслуживанию
    автомобилей и гарантийных обязательств марки ŠKODA перед клиентами в
    настоящий период Вы можете найти по
    <ProperLink href="/service/guarantee" mdxType="ProperLink"> ссылке </ProperLink>.
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="3" tags="index serviceinfo" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    Оригинальные детали и аксессуары ŠKODA
  </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Вы всегда можете подобрать необходимые оригинальные детали или аксессуары
    для Вашего автомобиля ŠKODA, воспользовавшись нашим онлайн-магазином.
  </DefaultSectionText>
  <PaddedTilesContainer mdxType="PaddedTilesContainer">
    <PaddedTilesTile imgSrc="/m/all_pages_parts.png" title="оригинальные аксессуары ŠKODA" href="https://parts.skoda-avto.ru/accessories" linkText="Перейти в каталог" mdxType="PaddedTilesTile" />
    <PaddedTilesTile imgSrc="/m/all_pages_acc.png" title="Оригинальные детали ŠKODA" href="https://parts.skoda-avto.ru/" linkText="Перейти в каталог" mdxType="PaddedTilesTile" />
  </PaddedTilesContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Мир ŠKODA</DefaultSectionHeading>
    </DefaultPaddedSection>
    <QueriedGallery presetName="3" tags="index skodaworld" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Сообщество ŠKODA</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    <p>
      Делитесь снимками на своей страничке с хэштегом #SKODARussia. Лучшие фото
      попадут в нашу ленту.
    </p>
    <p>Подписывайтесь на наши страницы.</p>
  </DefaultSectionText>
  <SocialBlockHOC itemCustomStyle="background: #fff; border: 1px solid #D8D8D8;" centerMode mdxType="SocialBlockHOC" />
  <SocialSliderQueried mdxType="SocialSliderQueried" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Где купить</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Дилерские центры ŠKODA расположены таким образом, чтобы Вы могли в любой
    момент обратиться в любой из них по интересующему Вас вопросу, будь то
    запись на плановое ТО, покупка нового автомобиля или сдача старого в
    trade-in. Здесь Вы найдете всю необходимую информацию для связи с дилером.
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedDlNew mdxType="QueriedDlNew" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      